import React, { memo, Suspense } from 'react';
import { Switch as RSwitch, Redirect } from 'react-router-dom';
import WaitLayout from '@components/WaitLayout'


function Switch({ fallback, children, includeNotFound = true, ...others }) {
  return (
    <Suspense fallback={<WaitLayout/>}>
      <RSwitch {...others}>
        {children}
        {/*{includeNotFound && <Redirect from="*" to="/404" />}*/}
      </RSwitch>
    </Suspense>
  );
}

export default memo(Switch);
